import { Component, NgModuleRef, Type } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UntypedFormBuilder } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { UsersService } from '../../services/users.service';
import { DashboardService } from '../../services/dashboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from 'app/services/orders.service';
// import { OpenOrdersCardComponent } from 'cards/open-orders-card/open-orders-card.component';
import { Injector } from '@angular/core';
import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { DynamicDashboardModule } from '../dynamic-dashboard.module';
import { Subject, ReplaySubject } from 'rxjs';


@Component({
	selector: 'app-user-dashboard',
	templateUrl: './user-dashboard.component.html',
	styleUrls: ['./user-dashboard.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				// transform: 'rotateY(179deg)',
				//safari does not like rotate Yputting the d
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			transition('active => inactive', animate('400ms ease-out')),
			transition('inactive => active', animate('400ms ease-in')),
			transition('inactive => orderlookup', animate('400ms ease-out')),
			transition('orderlookup => inactive', animate('400ms ease-in')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class UserDashboardComponent {
	newMessage: string;
	messageList: string[] = [];
	sender: any = [];
	flip = 'inactive';
	viewing: any = '';
	flip_text = '';
	color = 'blue'
	SENDER: any = [];
	messages = [];
	message: any = [];
	CHAT_ROOM = 'DashBoard';
	messageForm: any = [];
	config: any = false;
	userData;
	user: any;
	isPosUser = false;
	//new
	userDashJson: any = false;
	userComponentArray: any = [];
	userdash: any;
	complist = [];
	blankComponent: any = false;
	catlineSubject: ReplaySubject<any> = new ReplaySubject(1);



	constructor(private injector: Injector, private printService: PrintService, private router: Router, private sanitizer: DomSanitizer, public dashboardService: DashboardService, public formBuilder: UntypedFormBuilder, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private usersService: UsersService, private ordersService: OrdersService) {
		this.color = this.globalsService.getColor();
		this.userData = this.usersService.getLocalUser();
		// Stale-while-revalidate: emit cached catline data immediately if present,
		// then refresh in the background. Keeps the customer-type / category /
		// product-line cards from spinning every page load.
		const CATLINE_CACHE_KEY = 'dashboard.catline.v1';
		const CATLINE_TTL_MS = 10 * 60 * 1000;   // 10 minutes
		try {
			const raw = localStorage.getItem(CATLINE_CACHE_KEY);
			if (raw) {
				const cached = JSON.parse(raw);
				if (cached && cached.ts && (Date.now() - cached.ts) < CATLINE_TTL_MS && cached.data) {
					this.catlineSubject.next(cached.data);
				}
			}
		} catch { /* localStorage unavailable / corrupt — fall through to network */ }

		this.dashboardService.getCatAndLines().subscribe((res) => {
			this.catlineSubject.next(res);
			try { localStorage.setItem(CATLINE_CACHE_KEY, JSON.stringify({ ts: Date.now(), data: res })); } catch { /* quota etc — non-fatal */ }
		})

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			switch (this.config.env.package) {
			case 'beauty':
				this.usersService.isPosUser().subscribe((isPOS) => {
					if (isPOS) {
						this.isPosUser = true;
					}
				})
				break;
			}

			this.buildDashboard();
		});
	}



	ngAfterViewInit(): void {

	}



	buildDashboard() {
		this.getUserDashboardAndComponents();
	}

	getUserDashboardAndComponents() {
		const data = {
			userid: this.userData.user.userid,
			salesman: this.userData.user.salesman ? true : false,
			pos: this.isPosUser
		}

		this.usersService.getDashboard(data).subscribe((res) => {
			if (res['success']) {
				this.userdash = JSON.parse(res['dashboard']);
			} else {
				this.userdash = null;
			}
			this.getComponents();

		});


	}

	getComponents() {
		const moduleRef = this.injector.get(NgModuleRef<DynamicDashboardModule>);

		//get components from module
		for (const item of moduleRef['_r3Injector']['parent']['injectorDefTypes']) {
			const classname = Object.values(item)[0].toString().toLowerCase();
			if (classname.includes('dynamicdashboardmodule')) {
				item['ɵmod']['declarations'].forEach(component => {
					if (component['name'].toLowerCase().includes('blankcard')) {
						this.blankComponent = component;
					}
					if (component['name'].toLowerCase().includes('card') && this.userdash[component['name']]) {

						if (component['name'].toLowerCase().includes('blank')) { //only compononet allowed to have mult occurences
							this.userdash[component['name']].forEach(blankcard => {
								this.userComponentArray[blankcard['index']] = {
									component: this.blankComponent as Type<Component>,
									name: this.blankComponent['name'],
									view: this.blankComponent['name'].replace(/([A-Z])/g, ' $1').replace('Component', '').trim(),
									cardsize: blankcard['cardsize'],
								}
							});
						} else {

							this.userComponentArray[this.userdash[component['name']]['index']] = {
								component: component as Type<Component>,
								name: component['name'],
								view: component['name'].replace(/([A-Z])/g, ' $1').replace('Component', '').trim(),
								cardsize: this.userdash[component['name']]['cardsize'],
								'injector': Injector.create({
									providers: [
										{ provide: 'input', useValue: { 'userdata': this.userData, 'config': this.config, 'catlineObs': this.catlineSubject } },
										{ provide: 'output', useValue: (outputData: string) => this.toggleFlip(outputData) }
									],
									parent: this.injector
								})
							}
						}

					}
				});
			}
		}

		if (this.userComponentArray.length) {
			this.userComponentArray = Object.values(this.userComponentArray);
		}
	}



	//supporting fucns
	selectItemLookup(event: any) {
		if (this.isPosUser) {
			this.globalSearchService.setPreOrder(event);
			this.router.navigate(['./counter-pos/' + event.header.debtorno + '/' + event.header.branchcode]);
		} else {
			this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		}
	}


	toggleFlip(viewing: any) {
		this.viewing = viewing
		this.flip = (this.flip == 'active') ? 'inactive' : 'active';
	}

}
